export default "__VITE_ASSET__CbfP1tMV__"